import React from 'react';
import { buildNumberTextFieldInputProps } from '.';

import { FieldType, isInt32 } from '..';
import { InputValidationResult } from '../..';
import { FieldTypeEnumResponse } from '../../../.generated/admin-api';
import { apiTranslate } from '../../../translations/translations';
import { ValidatedTextInput } from '../../ValidatedTextInput';

type NumberFieldInputProps = {
  field: FieldType;
  required: boolean;
  value?: number;
  disabled?: boolean;
  onChangeValidator: (value?: number) => InputValidationResult;
};

const NumberField: React.FC<NumberFieldInputProps> = (props) => {
  const { field, required, value, disabled, onChangeValidator } = props;

  const handleChange = (value: string): InputValidationResult => {
    let numberValue: number | undefined;

    if (value) {
      switch (field.fieldType) {
        case FieldTypeEnumResponse.INTEGER:
          numberValue = parseInt(value);
          break;
        case FieldTypeEnumResponse.DOUBLE:
          numberValue = parseFloat(value);
          break;
        default:
          console.warn(
            'Unsupported field type for number field',
            field.fieldType,
          );
          numberValue = parseFloat(value);
          break;
      }
    }

    if (numberValue !== undefined && !isInt32(numberValue)) {
      numberValue = undefined;
    }

    return onChangeValidator(numberValue);
  };

  return (
    <ValidatedTextInput
      type="number"
      inputName={field.id}
      required={required}
      label={apiTranslate(field.title)}
      value={value !== undefined ? value : ''}
      onChangeValidator={handleChange}
      InputProps={buildNumberTextFieldInputProps(field)}
      disabled={disabled}
    />
  );
};

export { NumberField };
